import { formatWorldCityLabel } from "../store/slices/worldGeographySlice"

/** Normalize `worldCity` from GET clients/users/.../organization/... rows. */
export function normalizeWorldCityRow(worldCity) {
  if (!worldCity || worldCity.id == null || String(worldCity.id).trim() === "") {
    return null
  }
  return {
    id: worldCity.id,
    name: String(worldCity.name ?? "").trim(),
    worldState: worldCity.worldState ?? null,
    worldCountry: worldCity.worldCountry ?? worldCity.worldState?.worldCountry ?? null,
  }
}

export function getWorldCityId(client) {
  const id = client?.worldCity?.id
  if (id == null || String(id).trim() === "") return null
  return String(id)
}

export function getClientWorldCityName(client) {
  return client?.worldCity?.name?.trim() || ""
}

export function formatClientWorldCityLabel(client) {
  return formatWorldCityLabel(client?.worldCity) || ""
}

/** `[city, state, country]` for display labels. */
export function worldCityLocationParts(client) {
  const wc = client?.worldCity
  if (!wc) return []
  return [
    wc.name?.trim() || "",
    wc.worldState?.name?.trim() || "",
    wc.worldState?.worldCountry?.name?.trim() || wc.worldCountry?.name?.trim() || "",
  ].filter(Boolean)
}

export function formatClientLocationLabel(client) {
  const parts = worldCityLocationParts(client)
  if (parts.length) return parts.join(", ")
  return formatClientWorldCityLabel(client)
}

/** Org accounts list: "Chicago, Illinois (United States)" */
export function formatOrgAccountLocationLabel(client) {
  const wc = client?.worldCity
  if (!wc) return ""
  const city = wc.name?.trim() || ""
  const state = wc.worldState?.name?.trim() || ""
  const country =
    wc.worldState?.worldCountry?.name?.trim() || wc.worldCountry?.name?.trim() || ""

  if (city && state && country) {
    return `${city}, ${state} (${country})`
  }
  if (city && state) {
    return `${city}, ${state}`
  }
  if (city && country) {
    return `${city} (${country})`
  }
  return worldCityLocationParts(client).join(", ")
}
